import React, { useMemo } from "react";
import { STATUS, money } from "@/components/obboard/BoardFilters";
import { fmtCompact } from "@/lib/format";

const DOW = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const Chip = ({ it, onPick }) => (
  <button type="button" data-testid={`ob-cal-item-${it.obligation_id}-${it.due_date}`} onClick={() => onPick(it)}
    title={`${it.name}${it.entity ? ` · ${it.entity}` : ""} · ${STATUS[it.status].label}`}
    className={`w-full text-left text-[11px] leading-tight px-1.5 py-1 rounded-sm border transition-transform hover:-translate-y-px ${STATUS[it.status].cls}`}>
    <span className="block truncate font-medium">{it.name}</span>
    <span className="block mono opacity-80">{it.amount != null ? fmtCompact(it.amount, it.currency) : "amount varies"}{it.payment_mode === "auto" ? " · auto" : ""}</span>
  </button>
);

export const MonthCalendar = ({ month, items, onPick }) => {
  const { cells, byDay } = useMemo(() => {
    const [y, m] = month.split("-").map(Number);
    const first = new Date(y, m - 1, 1);
    const days = new Date(y, m, 0).getDate();
    const lead = (first.getDay() + 6) % 7;
    const list = [...Array(lead).fill(null), ...Array.from({ length: days }, (_, i) => i + 1)];
    while (list.length % 7) list.push(null);
    const map = {};
    items.forEach((it) => { const d = Number(it.due_date.slice(8, 10)); (map[d] = map[d] || []).push(it); });
    return { cells: list, byDay: map };
  }, [month, items]);
  const now = new Date();
  const todayDay = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}` === month ? now.getDate() : null;
  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid="ob-month-calendar">
      <div className="grid grid-cols-7 bg-slate-50 border-b border-slate-200">
        {DOW.map((d) => <div key={d} className="px-2 py-2 text-[11px] uppercase tracking-wider text-slate-500">{d}</div>)}
      </div>
      <div className="grid grid-cols-7">
        {cells.map((d, i) => {
          const list = d ? byDay[d] || [] : [];
          const sum = {};
          list.forEach((x) => { if (x.status !== "paid" && x.amount != null) sum[x.currency] = (sum[x.currency] || 0) + x.amount; });
          return (
            <div key={i} data-testid={d ? `ob-cal-day-${d}` : undefined}
              className={`min-h-[112px] border-b border-r border-slate-100 p-1.5 space-y-1 ${!d ? "bg-slate-50/50" : ""} ${d === todayDay ? "bg-blue-50/50" : ""}`}>
              {d && (
                <div className="flex items-center justify-between">
                  <span className={`text-xs mono ${d === todayDay ? "bg-blue-700 text-white rounded-full w-5 h-5 inline-flex items-center justify-center" : "text-slate-500"}`}>{d}</span>
                  {Object.keys(sum).length > 0 && <span className="text-[10px] mono text-slate-500">{money(sum, true)}</span>}
                </div>
              )}
              {list.map((it) => <Chip key={`${it.obligation_id}-${it.due_date}`} it={it} onPick={onPick} />)}
            </div>
          );
        })}
      </div>
    </div>
  );
};
